"use strict";
import { __module as u } from "./index.es376.js";
import { __require as M } from "./index.es377.js";
import { __require as j } from "./index.es293.js";
import { __require as O } from "./index.es378.js";
import { __require as S } from "./index.es294.js";
import { __require as w } from "./index.es379.js";
import { __require as W } from "./index.es292.js";
import { __require as I } from "./index.es380.js";
import { __require as T } from "./index.es381.js";
import { __require as A } from "./index.es382.js";
import { __require as D } from "./index.es383.js";
var d;
function K() {
  return d ? u.exports : (d = 1, (function(q, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "resolveHref", {
      enumerable: !0,
      get: function() {
        return H;
      }
    });
    const g = M(), c = j(), R = O(), y = S(), P = w(), U = W(), f = I(), b = T(), v = A(), z = D();
    function H(a, m, i) {
      let o, r = typeof m == "string" ? m : (0, c.formatWithValidation)(m);
      const n = r.match(/^[a-z][a-z0-9+.-]*:\/\//i), h = n ? r.slice(n[0].length) : r;
      if ((h.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
        console.error("Invalid href '" + r + "' passed to next/router in page: '" + a.pathname + "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.");
        const e = (0, y.normalizeRepeatedSlashes)(h);
        r = (n ? n[0] : "") + e;
      }
      if (!(0, U.isLocalURL)(r))
        return i ? [
          r
        ] : r;
      try {
        let e = r.startsWith("#") ? a.asPath : a.pathname;
        if (r.startsWith("?") && (e = a.asPath, (0, f.isDynamicRoute)(a.pathname))) {
          e = a.pathname;
          const s = (0, v.getRouteRegex)(a.pathname);
          (0, z.getRouteMatcher)(s)(a.asPath) || (e = a.asPath);
        }
        o = new URL(e, "http://n");
      } catch {
        o = new URL("/", "http://n");
      }
      try {
        const e = new URL(r, o);
        e.pathname = (0, P.normalizePathTrailingSlash)(e.pathname);
        let s = "";
        if ((0, f.isDynamicRoute)(e.pathname) && e.searchParams && i) {
          const _ = (0, g.searchParamsToUrlQuery)(e.searchParams), { result: p, params: L } = (0, b.interpolateAs)(e.pathname, e.pathname, _);
          p && (s = (0, c.formatWithValidation)({
            pathname: p,
            hash: e.hash,
            query: (0, R.omit)(_, L)
          }));
        }
        const l = e.origin === o.origin ? e.href.slice(e.origin.length) : e.href;
        return i ? [
          l,
          s || l
        ] : l;
      } catch {
        return i ? [
          r
        ] : r;
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), q.exports = t.default);
  })(u, u.exports), u.exports);
}
export {
  K as __require
};
//# sourceMappingURL=index.es291.js.map
